<template>

  <div class="news">
    <div class="inner-page-title"> Videos </div>
    <div class="bg_inner_page"
      style="background-image:url(/static/cdn/pexels-jakub-novacek-924824_vi4ina.jpg)">

    </div>
    <div class="news_body">
      <div class="container">

        <div class="row">

          <!-- BODY PAGE -->
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-12">
                <div class="posts_section">
                  <router-link :to="'/' " class="back-bt  button button--transparent-grad pulse">
                    <span>
                      Back
                    </span>
                  </router-link>
                  <div class="page_section_header">
                    <h2 class="sc">
                      MI videos
                    </h2>
                    <!-- <p>
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sit eius recusandae quas at ipsa iste,
                      voluptatibus rem! Architecto, consequatur dignissimos et, earum aliquam nobis ducimus error fugiat
                      autem, expedita non!
                    </p> -->
                  </div>
                  <div class="row">
                    <div class="col-sm-12">
                          <div class=" mobslider">
                            <div class="row ">
                              <div class="col-sm-6 " v-for="(item, index) in sliderData" :key="item.title" data-aos="zoom-in"
                                @click="playVideo( $event,item.video)">
                                <div class="mob-video">
                                  <div class="video-thumb">
                                    <img :src="item.thumb">
                                  </div>
                                  <h2>
                                    {{item.title}}
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>


                    </div>

                  </div>
                </div>

              </div>

            </div>

          </div>

          <!-- SIDE PAGE -->
          <div class="col-md-3 col-xs-12">
            <side-bare></side-bare>
          </div>
        </div>
      </div>

    </div>
  </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import global from '@/mixins/global';
  import videosData from '@/assets/data/videosData';
  import SideBare from "@/components/News/Parts/sidebare";
  import BigPicture from 'bigpicture';

  export default {
    mixins: [global],

    data() {
      return {
        sliderData:videosData
   
      }
    },
    created() {

    },
    methods: {
        playVideo(e, video) {
        console.log("triggered");
        BigPicture({
          el: e.target,
          // video src (String) or sources (Array)
          vidSrc: [video],
        });
      }
    },
    components:{SideBare}

  }

</script>

<style lang="scss">


  @import "../News/style";

  .posts_section {
    margin-right: 31px;
  }

  .sc {
    text-transform: capitalize;
  }

  .bg_inner_page {
    background-size: cover;
    width: 100%;
    height: 171px;
    margin-top: 25px;
    margin-bottom: 41px;
  }

</style>
<style scoped>
 @media screen and (min-width:1024px) {
    .mobslider{
      display: block;
    }
  }
.mob-video h2 {
    color: white;
    margin-bottom: 34px;
    margin: 21px;
    min-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/VideosPage/index.vue